export class GuidedTourStateModel {
    toggleOn: boolean;
}

export enum GuidedTourStatus {
    ON = 'ON',
    OFF = 'OFF'
}

